import { Injectable, inject } from '@angular/core';
import Session from '../utils/session.service';
import FetchingService from '../services/fetching.service';
import AngularHelperService from '../services/angular-helper.service';
import AngularFilterHelperService from '../services/angular-filter-helper.service';

@Injectable({ providedIn: 'root' })
export default class CategoryService {
	private session: Session = inject(Session);
	private fetchingService: FetchingService = inject(FetchingService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	
	store: any = {};
	
	getAll() {
		var deferred: any = this.angularHelperService.getDeferredPromise();
		
		setTimeout(() => {
			var user: any = this.session.getSession().user || {};
			this.fetchingService.get('CATEGORIES', {
				params: {
					language: user.deviceLanguage || 'et_EE',
					origin: user.origin,
					includeFurtherSubcategory: true,
					includeDescription: true
				}
			}).then((response) => {
				deferred.resolve(response);
			});
		}, 100);
		
		return deferred.promise;
	}
	
	initialize() {
		return this.getAll();
	}
	
	getFilters() {
		var deferred: any = this.angularHelperService.getDeferredPromise();
		if (this.store.filters) {
			deferred.resolve(this.store.filters);
			return deferred.promise;
		}
		
		this.getAll().then((categories) => {
			var data: any = categories.filter((category) => {
				return category.groupByParent && !category.furtherSubcategory || !category.groupByParent && category.furtherSubcategory;
			});
			data.unshift({ translation: this.angularFilterHelperService.translate('Services.Filter.Categories') });
			this.store.filters = data;
			deferred.resolve(data);
		});
		
		return deferred.promise;
	}
	
	getTranslation(category) {
		var deferred: any = this.angularHelperService.getDeferredPromise();
		var user: any = this.session.getSession().user || {};
		
		this.getAll().then((categories) => {
			var cat: any = categories.filter((item) => {
				if (category.furtherSubcategory) {
					return item.furtherSubcategory == category.furtherSubcategory;
				} else if (category.subcategory) {
					return item.subcategory == category.subcategory;
				} else {
					return item.category === category.category && !item.subcategory && !item.furtherSubcategory;
				}
			})[0] || {};
			deferred.resolve(cat.translation || '');
		});
		
		return deferred.promise;
	}
	
	getTranslationUsingDictionary(categories, category) {
		var cat: any = categories.filter((item) => {
			if (category.furtherSubcategory) {
				return item.furtherSubcategory == category.furtherSubcategory;
			} else if (category.subcategory) {
				return item.subcategory == category.subcategory;
			} else {
				return item.category === category.category && !item.subcategory && !item.furtherSubcategory;
			}
		})[0] || {};
		return cat.translation || '';
	}
	
}